import { Injectable, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { UrlService } from '@core/services/url/url.service';

import { AvailableRuleItem, RuleEvent } from '@app/models/rules';


/**
 * @deprecated
 */
@Injectable({
    providedIn: 'root'
})
export class RulesService {

    constructor(protected url: UrlService, protected http: HttpClient) {}
    // add object rule
    /**
     * @deprecated not used. Detected on jun-2024 <diego@twonas.com>
     * @returns 
     */
    findRules$() {
        return this.http
        .get(this.url.build("/rules/events"));
    }

    /**
     * @deprecated not used. Detected on jun-2024 <diego@twonas.com>
     * @returns 
     */
    findSettingsEvents$() {
        return this.http
        .get(this.url.build("/settings/rules/events"));
    }

    /**
     * @deprecated not used. Detected on jun-2024 <diego@twonas.com>
     * @param id 
     * @returns 
     */
    getRuleEvent$(id: Number) {
        return this.http.get<RuleEvent>(this.url.build("/rules/events/" + id ));
    }

    /**
     * @deprecated not used. Detected on jun-2024 <diego@twonas.com>
     * @param id 
     * @returns 
     */
    deactivateRuleEvent$(id: Number) {
        return this.http
        .delete(this.url.build("/rules/events/" + id ));
    }

    /**
     * @deprecated not used. Detected on jun-2024 <diego@twonas.com>
     * @param id 
     * @returns 
     */
    activateRuleEvent$(id: Number) {
        return this.http
        .put(this.url.build("/rules/events/" + id ),
            {active: true}
        );
    }

    /**
     * @deprecated not used. Detected on jun-2024 <diego@twonas.com>
     * @param event 
     * @returns 
     */
    updateRuleEvent$(event: RuleEvent) {
        let options = {headers: new HttpHeaders({
            'Content-Type':  'application/json',
        })};

        return this.http
        .put<RuleEvent>(this.url.build("/rules/events/" + event.id ),
            event,
            options
        );
    }

    /**
     * @deprecated not used. Detected on jun-2024 <diego@twonas.com>
     * @param event 
     * @returns httpResponse observable
     */
    addRuleEvent$(event: RuleEvent) {
        let options = {headers: new HttpHeaders({
            'Content-Type':  'application/json',
        })};
        
        if(event.id > 0)
            return this.updateRuleEvent$(event);
            
        return this.http.post<RuleEvent>(
            this.url.build("/rules/events"),
            event,
            options
        );
    }
}
